export default function clientApi (broker, cmp) {
  broker.on('open', ({ uiLevel, uuid }) => {
    if (uuid) {
      cmp.setUuid(uuid)
    }
    cmp.openUi(uiLevel)
  })

  broker.on('dissentUserToAll', () => {
    cmp.dissentToAll()
  })
}
